export default __webpack_public_path__ + "static/media/group_sandbox.670c0fb4.png";